import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, combineLatest, map } from 'rxjs';

import { Rights } from '@shared/enums';
import { AccountRights } from '@shared/models';
import { UserDetailsFacade } from '@shared/state/facades';
import { canMatchAccountGuard } from './account.guard';
import {
  canActivateAppStatusGuard,
  canMatchAppStatusGuard,
} from './app-status.guard';
import { canActivateClientGuard, canMatchClientGuard } from '.';
import { CanActivateFn, CanMatchFn } from '@shared/models/guard';

export const canActivateAdminGuard: CanActivateFn = (): Observable<boolean> => {
  const userDetailsFacade = inject(UserDetailsFacade);
  const router = inject(Router);

  return combineLatest([
    canMatchAccountGuard(),
    canActivateClientGuard(),
    canActivateAppStatusGuard(),
    userDetailsFacade.query.accountRights$,
  ]).pipe(
    map(([hasAccount, hasClient, isAppOnline, accountRights]) =>
      hasPermissions(router, hasAccount, hasClient, isAppOnline, accountRights)
    )
  );
};

export const canMatchAdminGuard: CanMatchFn = (): Observable<boolean> => {
  const userDetailsFacade = inject(UserDetailsFacade);
  const router = inject(Router);

  return combineLatest([
    canMatchAccountGuard(),
    canMatchClientGuard(),
    canMatchAppStatusGuard(),
    userDetailsFacade.query.accountRights$,
  ]).pipe(
    map(([hasAccount, hasClient, isAppOnline, accountRights]) =>
      hasPermissions(router, hasAccount, hasClient, isAppOnline, accountRights)
    )
  );
};

const hasPermissions = (
  router: Router,
  hasAccount: boolean,
  hasClient: boolean,
  isAppOnline: boolean,
  accountRights: AccountRights
): boolean => {
  if (
    !hasAccount ||
    !hasClient ||
    !isAppOnline ||
    accountRights.settingsRight === Rights.None
  ) {
    router.navigate(['/']);

    return false;
  }

  return true;
};
